module.exports = __webpack_public_path__ + "static/media/cashflow_placeholder_fr.f89c1363.png";